/**
 * Gemeinsame Texte der Live-Admin-Oberfläche (Paket 2, Persona-Runde 0 vom 28.10.2026).
 *
 * Regeln wie in der Webinar-Oberfläche (.claude/docs/webinar-ui-marketing.md): kein Fachbegriff außerhalb von
 * `NurAdmin`, ein Satz „wofür / was passiert" je Feld, Gutzustände grün in Worten. Alle Live-Flächen holen ihre
 * Begriffe von hier, damit ein Wort überall dasselbe heißt.
 */

/** Tooltip-Erklärungen der Kennzeichen für Live-Flächen (der Standard in marketingForm/texte.ts spricht von Webinaren). */
export const KENNZEICHEN_LIVE = {
  pflicht: 'Ohne dieses Feld lässt sich die Sendung nicht speichern.',
  empfohlen: 'Kann leer bleiben, ist für eine gute Sendung aber wichtig — der Satz am Feld sagt, warum.',
  optional: 'Kann leer bleiben — dann gilt der beschriebene Standard.',
  automatisch: 'Das System erledigt das selbst. Hier ist nichts zu tun.',
  admin: 'Technische Einstellung. Für die Sendung nicht nötig.',
} as const;

/**
 * Feste Begriffe. Links der Fachbegriff, der NICHT mehr in der Oberfläche stehen soll, rechts das Wort, das
 * stattdessen benutzt wird.
 */
export const BEGRIFF_LIVE = {
  session: 'Sendung',
  autoRoll: 'Werbevideo nach der Sendung',
  autoRollKurz: 'Werbevideo',
  endStream: 'Sendung beenden',
  placeholder: 'Wartebild',
  sonder: 'Zusatztermin',
  cta: 'Einblendung',
  defaultVideo: 'Standard-Werbevideo',
  goLive: 'Live gehen',
  override: 'Termin',
  schedule: 'Sendeplan',
  replay: 'Aufzeichnung',
  obsSignal: 'Signal aus dem Studio',
} as const;

/** Wen man fragt, wenn die Oberfläche etwas dem Admin zuweist oder etwas klemmt. */
export const TECHNIK_KONTAKT = 'Till Meier (Technik)';

/** Uhrzeit, zu der eine unbestätigte Sendung automatisch abgesagt wird (Cutoff, siehe live-streaming-system.md). */
export const BESTAETIGEN_BIS = '08:50';
